module.exports = __webpack_public_path__ + "img/instagram.f17d613.svg";